// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2SZfM","content":"RecentSearches_content__I-or3"};